var sampleArray =
 [
    {
      "id" : 1,
      "text" : " 最近的状态是：真的很累但还是想加油"
    },
    {
      "id" : 2,
      "text" : " ⽇益努⼒⽽后⻛⽣⽔起。"
    },
    {
      "id" : 3,
      "text" : "低⾕期的时候努⼒向上，成为别⼈眼中遥不可及的梦 "
    },
    {
      "id" : 4,
      "text" : "古之⽴⼤事者，不惟有超世之才，亦必有坚忍不拔之志"
    },
    {
      "id" : 5,
      "text" : "好运藏在努⼒⾥ "
    },
    {
      "id" : 6,
      "text" : "会突然在某⼀天让⼈看到坚持的意义 "
    },
    {
      "id" : 7,
      "text" : "积极者相信只有推动⾃⼰才能推动世界，只要推动⾃⼰就能推动世界 "
    },
    {
      "id" : 8,
      "text" : "驾驭命运的舵是奋⽃。不抱有⼀丝幻想，不放弃⼀点机会，不停⽌⼀⽇努⼒"
    },
    {
      "id" : 9,
      "text" : "没有热忱，世间便⽆进步 "
    },
    {
      "id" : 10,
      "text" : "努⼒的⼈，终将过上与努⼒相匹配的⽣活 "
    },
    {
      "id" : 11,
      "text" : "乾坤未定，你我皆是⿊⾺ "
    },
    {
      "id" : 12,
      "text" : "人间一趟，积极向上，不念过往，不畏将来"
    },
    {
      "id" : 13,
      "text" : "深夜一点半的灯光依旧闪烁，凌晨四点的闹钟也不只你一个"
    },
    {
      "id" : 14,
      "text" : "天道酬勤，精益求精，只争朝夕"
    },
    {
      "id" : 15,
      "text" : "习惯改变命运，细节铸就终身"
    },
    {
      "id" : 16,
      "text" : "先努⼒让⾃⼰发光，对的⼈才能迎着光⽽来"
    },
    {
      "id" : 17,
      "text" : "现在的⼀切都铸造了未来的⾃⼰ "
    },
    {
      "id" : 18,
      "text" : "这个世界从来不公平，你只有努⼒，才能换来那些平等的待遇 "
    },
    {
      "id" : 19,
      "text" : "这世上哪有从天⽽降的运⽓都是不为⼈知的努⼒"
    },
    {
      "id" : 20,
      "text" : "⾃律＋努⼒＋⽅法＋坚持＋时间＝优秀"
    },
    {
      "id" : 21,
      "text" : "⾼峰只对攀登它⽽不是仰望它的⼈来说才有真正意义 "
    },
    {
      "id" : 22,
      "text" : " 知⾜且坚定，温柔且上进 "
    },
    {
      "id" : 23,
      "text" : "⻛乍起，合当奋意，向此⽣ "
    },
    {
      "id" : 24,
      "text" : "不要惋惜以前的努⼒需要重来、有些路，注定不能省略"
    },
    {
      "id" : 25,
      "text" : "成功不是将来才有的，⽽是从决定去做的那⼀刻起，持续累积⽽成。 "
    },
    {
      "id" : 26,
      "text" : "当下的奋进与堕落，皆是⼀种积淀，它们会默默为你铺路 "
    },
    {
      "id" : 27,
      "text" : "当⼀个⼩⼩的⼼念变成为⾏为时，便能成了习惯；从⽽形成性格，⽽性格就决定你⼀⽣的成败。 "
    },
    {
      "id" : 28,
      "text" : "当⾃⼰累的时候，就转身看看身边在努⼒的⼈"
    },
    {
      "id" : 29,
      "text" : "那就在尘埃落定前奋⼒⼀搏 "
    },
    {
      "id" : 30,
      "text" : "那些看似不起波澜的⽇复⼀⽇，会突然在某⼀天让⼈看到坚持的意义"
    },
    {
      "id" : 31,
      "text" : "你只有⾮常努⼒，才能看起来毫不费⼒ "
    },
    {
      "id" : 32,
      "text" : "人生没有白走的路，每一步都算数"
    },
    {
      "id" : 33,
      "text" : "任何值得到达的地⽅，都没有捷径 "
    },
    {
      "id" : 34,
      "text" : "若结局⾮你所愿，那就在尘埃落定前奋⼒⼀搏"
    },
    {
      "id" : 35,
      "text" : "谁都不能阻⽌你成为优秀的⼈。"
    },
    {
      "id" : 36,
      "text" : "天赋决定上限，努力决定下限"
    },
    {
      "id" : 37,
      "text" : "我要悄悄拔尖，然后惊艳所有⼈"
    },
    {
      "id" : 38,
      "text" : "只要你足够努力，阳光会穿破厚厚的云层，照进你的人生"
    },
    {
      "id" : 39,
      "text" : "⼀个⼈⼏乎可以在任何他怀有⽆限热忱的事情上成功 "
    },
    {
      "id" : 40,
      "text" : "⼈⽣没有⽩⾛的路，每⼀步都算数。"
    },
    {
      "id" : 41,
      "text" : "⼈⽣只有⾛出来的美丽，没有等出来的辉煌 "
    },
    {
      "id" : 42,
      "text" : " 通往光明的道路是平坦的，为了成功，为了奋⽃的渴望，我们不得不努力 "
    },
    {
      "id" : 43,
      "text" : " 业精于勤，荒于嬉；⾏成于思，毁于随。"
    },
    {
      "id" : 44,
      "text" : "⻦欲⾼⻜先振翅，⼈求上进先读书 "
    },
    {
      "id" : 45,
      "text" : "不想被别⼈否定，⾃⼰就要更加努⼒"
    },
    {
      "id" : 46,
      "text" : "此时不搏何时搏？全⼒以赴，铸我辉煌！"
    },
    {
      "id" : 47,
      "text" : "从来只有拼出来的美丽，没有等出来的辉煌"
    },
    {
      "id" : 48,
      "text" : "当你停下休息的时候，不要忘了别⼈还在奔跑 "
    },
    {
      "id" : 49,
      "text" : "当你休息的时候记得回头看看，别⼈都在奔跑 "
    },
    {
      "id" : 50,
      "text" : "高度自律即绝对自由，你偷过的懒，都会成为日后的遗憾"
    },
    {
      "id" : 51,
      "text" : "每⼀次努⼒，都是幸运的伏笔 "
    },
    {
      "id" : 52,
      "text" : "你觉得这条路很难走的时候，一定是上坡路"
    },
    {
      "id" : 53,
      "text" : "你只管努⼒，剩下的交给时间。 "
    },
    {
      "id" : 54,
      "text" : "逆⻛的⽅向，更适合奋⼒⻜翔 "
    },
    {
      "id" : 55,
      "text" : "年轻⼈请努⼒，让⾃⼰出⾊，从能⼒到容貌."
    },
    {
      "id" : 56,
      "text" : "稍微不努⼒，就会被后者反超"
    },
    {
      "id" : 57,
      "text" : "同是⻛华正茂，何⽢他⼈之后"
    },
    {
      "id" : 58,
      "text" : "我⾛的很慢，但绝不后退"
    },
    {
      "id" : 59,
      "text" : "现在努⼒，就是去⻅未来你想⻅的⼈ "
    },
    {
      "id" : 60,
      "text" : "要努力，但是不要急。繁花锦簇，硕果累累都需要过程"
    },
    {
      "id" : 61,
      "text" : "⽆论才能、知识多么卓著，如果缺乏热情，则⽆异纸上画饼充饥，⽆补于事 "
    },
    {
      "id" : 62,
      "text" : "⽐你差的⼈还没放弃，⽐你好的⼈还在努⼒ "
    },
    {
      "id" : 63,
      "text" : " 你的爱⾖都在努⼒，你还凭什么不去努⼒？ "
    },
    {
      "id" : 64,
      "text" : " 努⼒就是光，成功就是影。没有光哪⼉来影？ "
    },
    {
      "id" : 65,
      "text" : "身边⽐你优秀的⼈⽐你还努⼒"
    },
    {
      "id" : 66,
      "text" : "不论你在什么时候开始，重要的是开始之后就不要停止"
    },
    {
      "id" : 67,
      "text" : "不努⼒的⼈听到的总是别⼈的好消息"
    },
    {
      "id" : 68,
      "text" : "当你觉得为时已晚的时候，恰恰是最早的时候 "
    },
    {
      "id" : 69,
      "text" : "凡事趁早，没有那么多来⽇⽅⻓"
    },
    {
      "id" : 70,
      "text" : "奋⽃没有终点，任何时候都是⼀个起点。 "
    },
    {
      "id" : 71,
      "text" : "构成我们学习最⼤障碍的是已知的东⻄，⽽不是未知的东⻄。"
    },
    {
      "id" : 72,
      "text" : "没有那么多天赋异禀，优秀的人总是努力翻山越岭"
    },
    {
      "id" : 73,
      "text" : "你始终⽋⾃⼰⼀个努⼒的模样"
    },
    {
      "id" : 74,
      "text" : "你要明⽩，学习不难，是你努⼒不够 "
    },
    {
      "id" : 75,
      "text" : "事趁早，没有那么多来⽇⽅⻓。 "
    },
    {
      "id" : 76,
      "text" : "学习成⻓的机会不在未来，⽽在每⼀个活着的当下 "
    },
    {
      "id" : 77,
      "text" : "要像星星，努⼒发光。"
    },
    {
      "id" : 78,
      "text" : "有什么⼀夜成名，其实都是百炼成钢 "
    },
    {
      "id" : 79,
      "text" : "⼤多数⼈想要改造这个世界，但却罕有⼈想改造⾃⼰ "
    },
    {
      "id" : 80,
      "text" : "⾏动是治愈恐惧的良药，⽽犹豫、拖延将不断滋养恐惧 "
    }
  ]

  export function getArray(id) {
    if(id>0){
      return sampleArray[id-1]
    }else{
      return sampleArray[id]
    }
    
  }
